// package: profile
// file: apigateway/profile/blog_order.proto

import * as apigateway_profile_blog_order_pb from "../../apigateway/profile/blog_order_pb";
import * as apigateway_profile_blog_charge_pb from "../../apigateway/profile/blog_charge_pb";
import * as profileservice_blog_pb from "../../profileservice/blog_pb";
import * as profileservice_blog_order_pb from "../../profileservice/blog_order_pb";
export class BlogOrderService {
  static serviceName = "profile.BlogOrderService";
}
export namespace BlogOrderService {
  export class ExecutePayment {
    static readonly methodName = "ExecutePayment";
    static readonly service = BlogOrderService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_blog_order_pb.ExecutePaymentRequest;
    static readonly responseType = apigateway_profile_blog_order_pb.ExecutePaymentReply;
  }
  export class CompleteBlogOrder {
    static readonly methodName = "CompleteBlogOrder";
    static readonly service = BlogOrderService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_blog_order_pb.CompleteBlogOrderRequest;
    static readonly responseType = apigateway_profile_blog_order_pb.CompleteBlogOrderReply;
  }
  export class GetBlogOrder {
    static readonly methodName = "GetBlogOrder";
    static readonly service = BlogOrderService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_blog_order_pb.GetBlogOrderRequest;
    static readonly responseType = apigateway_profile_blog_order_pb.GetBlogOrderReply;
  }
  export class GetBlogOrderHistories {
    static readonly methodName = "GetBlogOrderHistories";
    static readonly service = BlogOrderService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_blog_order_pb.GetBlogOrderHistoriesRequest;
    static readonly responseType = apigateway_profile_blog_order_pb.GetBlogOrderHistoriesReply;
  }
}
